import "./login.css";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "react-bootstrap/";
import Logo from "./../../assets/logo.svg";
import { TextField, Button } from "@mui/material";
import { TailSpin } from "react-loader-spinner";
import axios from "../../network/api";
import { baseUrl } from "../../network/constants/constants";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Login() {
  const [phone, setPhone] = useState("");
  const [loading, setLoading] = useState(false);
  const [phoneError, setPhoneError] = useState(false);
  const navigate = useNavigate();

  const handlePhone = (event) => {
    setPhone(event.target.value);
  };

  const validatePhone = (phone) => {
    const regex = /^(?:\+91\s?)?[6-9]\d{9}$/;
    setPhoneError(!regex.test(phone));
    return regex.test(phone);
  };

  const handleLogin = () => {
    if (!validatePhone(phone)) {
      toast.error("Invalid phone number");
      return;
    }

    setLoading(true);

    // Clear previous login status before new attempt
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("isOtpVerified");
    // Notify App.jsx about local storage changes immediately (optional but helps)
    window.dispatchEvent(new Event('authUpdate')); 

    axios
      .post(`${baseUrl}auth/auth/login/`, { phone: phone })
      .then((response) => {
        // Set isLoggedIn status
        localStorage.setItem("isLoggedIn", "true");
        // Notify App.jsx to update its state
        window.dispatchEvent(new Event('authUpdate')); 
        
        navigate("/otp", {
          state: { data: { phone: phone } },
          replace: true,
        });
      })
      .catch((error) => {
        console.error(error);
        toast.error("Login failed! Please check the number");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <section id="login">
      <div className="content">
        <div className="brand-container">
          <img alt="logo" src={Logo} className="logo" />
          <div className="business-name">Onescribe Super Admin Panel</div>
        </div>

        <Card className="login-card card mt-5 rounded-4">
          <div className="login-title">Login</div>

          <TextField
            id="phone"
            className="mt-4"
            label="Phone"
            variant="outlined"
            size="small"
            type="tel"
            value={phone}
            onChange={handlePhone}
            error={phoneError}
            helperText={phoneError ? "Invalid Mobile Number" : ""}
          />

          <Button
            variant="contained"
            className="login-btn mt-5 mb-3"
            onClick={handleLogin}
            disabled={loading}
          >
            Submit
          </Button>

          <div className="spiner-container">
            <TailSpin
              height="30"
              width="30"
              radius="1"
              color="#ffbe00"
              ariaLabel="loading"
              visible={loading}
            />
          </div>
        </Card>
      </div>

      <a href="tel:+91" className="contact">
        ⓘ Contact Us
      </a>
      <ToastContainer position="top-center" autoClose={3000} hideProgressBar />
    </section>
  );
}

export default Login;